export const REBRAND_BLOG_POST_KEY = 'has_seen_rebrand_message';

export const JOIN_SUGGESTED_WORKSPACE_TOOLTIP_DISMISSED =
  'join_suggested_workspace_tooltip_dismissed';

export const JOIN_SUGGESTED_WORKSPACE_BANNER_DISMISSED =
  'join_suggested_workspace_banner_dismissed';

export const JOIN_SUGGESTED_WORKSPACE_DISMISSAL_TIME =
  'join_suggested_dismissal_time';

export const JOIN_SUGGESTED_WORKSPACE_WORKSPACE_SWITCHER_DISMISSED =
  'join_suggested_workspace_workspace_switcher_dismissed';

export const SEEN_SUGGESTED_WORKSPACE_WORKSPACE_SWITCHER =
  'seen_suggested_workspace_workspace_switcher';

export const AUTOJOIN_DISMISSAL_TIME = 'autojoin_dismissal_time';

export const GET_STARTED_CHECKLIST_IS_MINIMIZED =
  'get_started_checklist_is_minimized';

export const AUTOJOIN_TOOLTIP_DISMISSED = 'autojoin_tooltip_dismissed';

export const AUTOJOIN_BANNER_DISMISSED = 'autojoin_banner_dismissed';

export const INVITE_CALLOUT_DISMISSED =
  'navigationSidebarInviteCalloutDisabled';

export const SHARE_WITH_ME_FTUX_TOOLTIP_DISMISSED =
  'share_with_me_ftux_tooltip_dismissed';

export const SHARE_MODAL_FTUX_TOOLTIP_DISMISSED =
  'share_modal_ftux_tooltip_dismissed';

export const INVITE_MODAL_INVITE_LINK_FTUX_TOOLTIP_DISMISSED =
  'invite_modal_invite_link_ftux_tooltip_dismissed';

export const TAGS_STEP_1_FTUX_TOOLTIP_DISMISSED =
  'tags_step_1_ftux_tooltip_dismissed';

export const TAGS_STEP_2_FTUX_TOOLTIP_DISMISSED =
  'tags_step_2_ftux_tooltip_dismissed';

export const PUBLISH_SETTINGS_FTUX_TOOLTIP_DISMISSED =
  'publish_settings_ftux_tooltip_dismissed';

export const STORAGE_INCENTIVES_FTUX_BUTTON_DISMISSED =
  'storage_incentives_ftux_button_dismissed';

export const APPROACHING_CONTENT_LIMIT_BANNER_DISMISSED =
  'approaching_content_limit_banner_dismissed';

export const APPROACHING_CONTENT_LIMIT_CHIP_DISMISSED =
  'approaching_content_limit_chip_dismissed';

export const STORAGE_INCENTIVE_FTUX_INVITE_SENT =
  'storage_incentive_ftux_invite_sent';

export const STORAGE_INCENTIVE_FTUX_VISITED_TRACK_TAB =
  'storage_incentive_ftux_visited_track_tab';

export const STORAGE_INCENTIVES_INVITE_MODAL_BANNER_DISMISSED =
  'storage_incentive_invite_modal_banner_dismissed';

export const WORKSPACE_CONTACT_IMPORT_INTEGRATIONS_TOOLTIP_DISMISSED =
  'workspace_contact_import_integrations_tooltip_dismissed';

export const JOIN_WORKSPACE_BANNER_DISMISSED =
  'join_workspace_banner_dismissed';

export const PLAYBACK_RATE = 'playback-rate';
export const PAUSE_NUDGE_DISMISSED = 'PAUSE_NUDGE_DISMISSED';
